import state from '../state';
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';

export default function timeAgo (timestamp) { // @TODO i18n
  let input = new Date(timestamp * 1000);

  if (typeof timestamp === 'string') {
    input = new Date(timestamp);
  }

  const now = new Date();

  if (now - input < 60000) {
    return state.t('compact_date_suffix.now');
  }
  
  return formatDistanceToNowStrict(input, {
    locale: state.locale.dateLocale,
    addSuffix: true,
  });
}
